import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/pk/success.png';
import _imports_1 from '@/assets/img/pk/fail.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5c553fe5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "title"
};
var _hoisted_2 = ["onClick", "name"];
var _hoisted_3 = {
  key: 0,
  class: "pk-tip-icon",
  src: _imports_0,
  alt: ""
};
var _hoisted_4 = {
  key: 1,
  class: "pk-tip-icon",
  src: _imports_1,
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$props$data, _ctx$$store$getters$g, _$props$data2;
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["choice-wrap", {
      isPk: $props.isPk
    }])
  }, [_createElementVNode("h1", _hoisted_1, _toDisplayString($props.index + 1) + "、" + _toDisplayString((_$props$data = $props.data) === null || _$props$data === void 0 ? void 0 : _$props$data.title), 1), _createElementVNode("ul", {
    class: _normalizeClass(["list-wrap", {
      normal: $props.isNormal,
      'left-style': ((_ctx$$store$getters$g = _ctx.$store.getters.getQuesSetting) === null || _ctx$$store$getters$g === void 0 ? void 0 : _ctx$$store$getters$g.answerStatus) === 2
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_$props$data2 = $props.data) === null || _$props$data2 === void 0 ? void 0 : _$props$data2.optionVoList, function (item) {
    var _ctx$$store$getters$g2, _ctx$$store$getters$g3, _ctx$$store$getters$g4;
    return _openBlock(), _createElementBlock("li", {
      onClick: function onClick($event) {
        return $setup.handleOptionClick(item);
      },
      key: item.optionKey,
      name: item.optionKey,
      class: _normalizeClass(["list-item", {
        selected: item.select && ((_ctx$$store$getters$g2 = _ctx.$store.getters.getQuesSetting) === null || _ctx$$store$getters$g2 === void 0 ? void 0 : _ctx$$store$getters$g2.answerStatus) !== 2,
        right: item.select && item.isRight === 1 || $setup.isSelected && ((_ctx$$store$getters$g3 = _ctx.$store.getters.getQuesSetting) === null || _ctx$$store$getters$g3 === void 0 ? void 0 : _ctx$$store$getters$g3.answerStatus) === 2 && item.isRight === 1,
        'wrong animate__animated animate__shakeX': item.select && item.isRight === 0
      }])
    }, [_createTextVNode(_toDisplayString(item.content) + " ", 1), $props.isPk ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [item.select && item.isRight === 1 || $setup.isSelected && ((_ctx$$store$getters$g4 = _ctx.$store.getters.getQuesSetting) === null || _ctx$$store$getters$g4 === void 0 ? void 0 : _ctx$$store$getters$g4.answerStatus) === 2 && item.isRight === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), item.select && item.isRight === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 10, _hoisted_2);
  }), 128))], 2)], 2);
}